import axios from 'axios';
import { getConfig } from '../../reducers/portalConfig';
import * as CONSTANTS from '../../constants';
import { getValidationErrors } from '../../utils';

export const processAccountSetup = (payload, publicKey) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal?.hostname}/admin/accountSetup?token=${payload.token}`;

  dispatch({ type: CONSTANTS.UPDATE_ACCOUNT_SETUP_REQUEST })

  const headers = {};
  if(publicKey) {
    headers['Public-Key'] = publicKey;
  }

  await axios.put(url, payload, { credentials: 'include', headers })
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        dispatch({ type: CONSTANTS.UPDATE_ACCOUNT_SETUP_SUCCESS, payload: response.data });
      }
    })
    .catch((error) => {
      const response = error?.response || {};
      const errorData = response.data?.error;

      if (response.status === 400 && errorData) {
        dispatch({ type: CONSTANTS.UPDATE_ACCOUNT_SETUP_ERROR, payload: response.data?.error || '' });
        return;
      }
      
      if (response.status === 400 && response.data?.errorCode === 511) {
        dispatch({ type: CONSTANTS.UPDATE_ACCOUNT_SETUP_ERROR, payload: { invalidToken: true } });
        return;
      }
      
      if (response.status === 400 && response.data?.validationErrors) {
        let errorMessage = '';
        Object.entries(response.data?.validationErrors).map(function ([, value]) {
          if (value.localizedMessage) {
            errorMessage = errorMessage + value.localizedMessage + '\n';
          }
        });
        if (errorMessage) {
          dispatch({ type: CONSTANTS.UPDATE_ACCOUNT_SETUP_ERROR, payload: errorMessage })
        }
        return;
      }
      
      if (errorData?.detail?.errorCode) {
        const errorCode = errorData.detail?.errorCode;
        dispatch({ type: CONSTANTS.UPDATE_ACCOUNT_SETUP_ERROR, payload: { errorCode } });
        return;
      }

      dispatch({ type: CONSTANTS.UPDATE_ACCOUNT_SETUP_ERROR, payload: '' })
    });
};

export const getAccountSetupData = payload => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal?.hostname}/admin/accountSetup?token=${payload}`;

  dispatch({ type: CONSTANTS.ACCOUNT_SETUP_TOKEN_REQUEST })

  await axios.get(url)
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        dispatch({ type: CONSTANTS.ACCOUNT_SETUP_TOKEN_SUCCESS, payload: response.data });
      }
    })
    .catch((error) =>
      dispatch({ type: CONSTANTS.ACCOUNT_SETUP_TOKEN_ERROR, payload: getValidationErrors(error) }),
    );
}